import React, { useContext, useEffect } from "react";
import { useRouter } from "next/router";
import { RequestNextApi } from "../../api/Request";
import { ProgressContext } from "../../components/Context/progressContext";
import { ShowNotification } from "../../utils/notification/snackbarUtils";

export default function VanityUrl() {
  const { update: updateProgress } = useContext(ProgressContext);
  const router = useRouter();
  const { pid } = router.query;

  const fetchAdvisorUrl = async () => {
    try {
      const res = await RequestNextApi.post("/cka/vanity-url", {
        vanityUrl: pid,
      });
      if (res.data && res.data.success) {
        router.push(
          `https://www.faithfi.com/cka/${res?.data?.userId}/${res?.data?.shipzip}`
        );
      } else {
        ShowNotification.error(res.data.message);
      }
    } catch (error) {
      router.push("/not-found");
    }
  };

  useEffect(() => {
    const initPage = async (pid) => {
      updateProgress({ isLoading: true });
      await fetchAdvisorUrl(pid);
      updateProgress({ isLoading: false });
    };

    if (pid) {
      initPage(pid);
    }
  }, [pid]);

  return <></>;
}
VanityUrl.isPublic = true;
VanityUrl.getLayout = (page) => <>{page}</>;
